import { Slide } from '@/components/core/Slide';
import videoFile from './15-bubbles.webm';
import audioFile from './22-time-warning.mp3';

const autoNextDuration = 24000;
const transcript = `
  Hebben we dan alles gehad?  

  Denk vooral aan de tijd! Een dag vliegt zo voorbij. Ik adviseer echt om zo snel mogelijk na te denken over jullie 
  deliverables en deze ook daadwerkelijk te maken. Als je daarna nog tijd over hebt, kun je ze altijd verbeteren. 
  Maar het zou zonde zijn als jullie een geweldig idee hebben en geen tijd meer om het goed uit te werken voor 
  jullie presentatie!
`;

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      autoNext={autoNextDuration}
      audio={audioFile}
      visualizer="full"
      transition="fade"
      background={{
        video: videoFile,
      }}
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
